import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { fetchAllProperties ,updateProperty ,deleteProperty} from '../actions/propertyActions';

const initialState = {
  properties: [],
  loading: false,
  error: null,
  pagination: null
};

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProperties.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllProperties.fulfilled, (state, action) => {
        state.loading = false;
        state.properties = action.payload?.data?.all || [];
        state.pagination = action.payload?.paginate || null;
      })
      .addCase(fetchAllProperties.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch properties';
      })

      .addCase(updateProperty.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProperty.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateProperty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to update property';
      })

      .addCase(deleteProperty.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // .addCase(deleteProperty.fulfilled, (state, action) => {
      //   state.loading = false;
      
      //   // remove inactive property from UI immediately
      //   state.properties = state.properties.filter(
      //     (p) => p.id !== action.payload.propertyId
      //   );
      // })
      .addCase(deleteProperty.fulfilled, (state, action) => {
        state.loading = false;
      
        const deletedId = action.payload?.propertyId;
      
        if (deletedId) {
          state.properties = state.properties.filter(
            (p) => p.id !== deletedId
          );
        }
        toast.success(action.payload?.data?.message || 'Property deleted successfully');
      })
      .addCase(deleteProperty.rejected, (state, action) => {
        state.loading = false;
        const message = action.payload?.message || 'Failed to delete property';
        state.error = message;
        toast.error(message);
      });
      
      
  },
});

export default propertySlice.reducer;
